import { DESIGN_SIZES, PM2PrintHeaderSlot, printManager } from '@provider/print';
import { units } from '@ui/css';
import { PrintFooter } from './footer.js';
import { ComponentHeader } from './header.context.js';
import { makePrintPageTaskChunk } from './page-content/_page-content.js';
import { jsx } from 'react/jsx-runtime';

function makeIGuidePrintSection(component, slots) {
  return {
    pages: [{
      type: "offset",
      padding: context => ({
        top: context.physical?.currentPageIndexInSection === 0 ? units.px(12) : units.px(35),
        bottom: units.px(25)
      }),
      chunks: [{
        content: /*#__PURE__*/jsx(ComponentHeader, {
          component: component
        })
      }, ...component.data.tasks.flatMap((task, index) => makePrintPageTaskChunk(task, component.entryKey, index, {
        includeHeading: component.data.tasks.length > 1
      }))]
    }],
    config: {
      slots: {
        header: PM2PrintHeaderSlot,
        footer: context => ({
          content: /*#__PURE__*/jsx(PrintFooter, {
            context: context
          }),
          designSizeInPx: DESIGN_SIZES.ONE_TO_ONE("A4-portrait")
        }),
        ...slots
      },
      designSizeInPx: DESIGN_SIZES.ONE_TO_ONE("A4-portrait")
    }
  };
}
async function prepareIGuidePrint(component, target) {
  await printManager.preparePrint(`i-guide-${Math.random()}`, target, {
    debug: false,
    format: "A4-portrait",
    sections: [makeIGuidePrintSection(component)]
  });
}

export { makeIGuidePrintSection, prepareIGuidePrint };
//# sourceMappingURL=util.prepare-print.js.map
